if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template')
          .content.firstElementChild.cloneNode(true);

        this.onClickRefreshList = this.onClickRefreshList.bind(this);

        this.fetchAvailability(this.getAttribute('data-variant-id'));
      }

      fetchAvailability(variantId) {
        let rootUrl = this.getAttribute('data-root-url');

        if (!rootUrl.endsWith('/')) {
          rootUrl += '/';
        }

        fetch(`${rootUrl}variants/${variantId}/?section_id=pickup-availability`)
          .then((response) => response.text())
          .then((responseText) => {
            const parsedDocument = new DOMParser().parseFromString(
              responseText,
              'text/html'
            );

            const sectionInnerHTML =
              parsedDocument.querySelector('.shopify-section');

            this.renderPreview(sectionInnerHTML);
          })
          .catch(() => {
            const button = this.querySelector('button');

            if (button) {
              button.removeEventListener(
                'click',
                this.onClickRefreshList
              );
            }

            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(
          this.getAttribute('data-variant-id')
        );
      }

      update(variant) {
        if (variant?.available) {
          this.setAttribute('data-variant-id', variant.id);
          this.fetchAvailability(variant.id);
        } else {
          this.innerHTML = '';
          this.removeAttribute('available');
          this.setAttribute('hidden', '');
        }
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        const button = this.querySelector('button');

        if (button) {
          button.addEventListener(
            'click',
            this.onClickRefreshList
          );
        }
      }

      isAvailable(card) {
        const text = (card?.textContent || '').toLowerCase();

        if (
          text.includes('currently unavailable') ||
          text.includes('pickup currently unavailable') ||
          text.includes('unavailable') ||
          text.includes('ØºÙŠØ± Ù…ØªÙˆÙØ±')
        ) {
          return false;
        }

        return (
          text.includes('pickup available') ||
          text.includes('usually ready') ||
          text.includes('ready in') ||
          text.includes('Ù…ØªÙˆÙØ±')
        );
      }

      getPriority(card) {
        const text = (card?.textContent || '').toLowerCase();

        if (
          text.includes('rehab') ||
          text.includes('Ø§Ù„Ø±Ø­Ø§Ø¨')
        ) {
          return 1;
        }

        if (
          text.includes('garden 8') ||
          text.includes('garden') ||
          text.includes('Ø¬Ø§Ø±Ø¯Ù† 8') ||
          text.includes('Ø¬Ø§Ø±Ø¯Ù†')
        ) {
          return 2;
        }

        if (
          text.includes('west yard') ||
          text.includes('sheikh zayed') ||
          text.includes('sheikh zayed') ||
          text.includes('ÙˆÙŠØ³Øª ÙŠØ§Ø±Ø¯') ||
          text.includes('Ø§Ù„Ø´ÙŠØ® Ø²Ø§ÙŠØ¯')
        ) {
          return 3;
        }

        if (
          text.includes('marassi') ||
          text.includes('north coast') ||
          text.includes('Ù…Ø±Ø§Ø³ÙŠ') ||
          text.includes('Ø§Ù„Ø³Ø§Ø­Ù„ Ø§Ù„Ø´Ù…Ø§Ù„ÙŠ')
        ) {
          return 4;
        }

        return 99;
      }

      sortStoreCards(list) {
        const cards = Array.from(list.children);

        cards.sort((a, b) => {
          const aAvailable = this.isAvailable(a);
          const bAvailable = this.isAvailable(b);

          /*
           * Ø§Ù„Ù…ØªÙˆÙØ± Ø¯Ø§Ø¦Ù…Ø§Ù‹ ÙŠØ¸Ù‡Ø± Ù‚Ø¨Ù„ ØºÙŠØ± Ø§Ù„Ù…ØªÙˆÙØ±.
           */
          if (aAvailable !== bAvailable) {
            return aAvailable ? -1 : 1;
          }

          /*
           * Ø¹Ù†Ø¯ ØªØ³Ø§ÙˆÙŠ Ø­Ø§Ù„Ø© Ø§Ù„ØªÙˆÙØ±ØŒ Ù†Ø·Ø¨Ù‚ ØªØ±ØªÙŠØ¨ Ø§Ù„ÙØ±ÙˆØ¹.
           */
          return this.getPriority(a) - this.getPriority(b);
        });

        cards.forEach((card) => {
          list.appendChild(card);
        });
      }

      createStatusIcon(isAvailable) {
        const iconNamespace = 'http://www.w3.org/2000/svg';
        const svg = document.createElementNS(iconNamespace, 'svg');

        svg.setAttribute('viewBox', '0 0 24 24');
        svg.setAttribute('stroke', 'none');
        svg.setAttribute('fill', 'currentColor');
        svg.setAttribute('xmlns', iconNamespace);
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');

        if (isAvailable) {
          svg.setAttribute(
            'class',
            'icon icon-check-circle-filled icon-sm shrink-0 pickup-availability-status-icon'
          );

          svg.innerHTML = `
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM17.0303 10.0303C17.3232 9.73744 17.3232 9.26256 17.0303 8.96967C16.7374 8.67678 16.2626 8.67678 15.9697 8.96967L11 13.9393L9.03033 11.9697C8.73744 11.6768 8.26256 11.6768 7.96967 11.9697C7.67678 12.2626 7.67678 12.7374 7.96967 13.0303L10.4697 15.5303C10.6103 15.671 10.8011 15.75 11 15.75C11.1989 15.75 11.3897 15.671 11.5303 15.5303L17.0303 10.0303Z"
            ></path>
          `;
        } else {
          svg.setAttribute(
            'class',
            'icon icon-alert-circle-filled icon-sm shrink-0 pickup-availability-status-icon'
          );

          svg.innerHTML = `
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12.75 7C12.75 6.58579 12.4142 6.25 12 6.25C11.5858 6.25 11.25 6.58579 11.25 7V13C11.25 13.4142 11.5858 13.75 12 13.75C12.4142 13.75 12.75 13.4142 12.75 13V7ZM12 15.25C11.3096 15.25 10.75 15.8096 10.75 16.5C10.75 17.1904 11.3096 17.75 12 17.75C12.6904 17.75 13.25 17.1904 13.25 16.5C13.25 15.8096 12.6904 15.25 12 15.25Z"
            ></path>
          `;
        }

        return svg;
      }

      updatePreviewIcon(preview, isAvailable) {
        if (!preview) return;

        const info = preview.querySelector(
          '.pickup-availability-info'
        );

        if (!info) return;

        info.className = isAvailable
          ? '_tmp-63u pickup-availability-info flex items-start gap-2d5'
          : '_flx-bgh pickup-availability-info flex items-start gap-2d5';

        const currentIcon =
          info.querySelector(
            '.pickup-availability-status-icon'
          ) ||
          info.querySelector('svg') ||
          info.querySelector('.icon');

        const newIcon = this.createStatusIcon(isAvailable);

        if (currentIcon) {
          currentIcon.replaceWith(newIcon);
        } else {
          info.prepend(newIcon);
        }
      }

      updatePreviewFromFirstStore(preview, firstStore) {
        if (!preview || !firstStore) return;

        const firstStoreText =
          firstStore.textContent || '';

        const firstStoreNameEl =
          firstStore.querySelector(
            'h3, h4, .h4, [data-location-name], strong'
          );

        const firstStoreTimeEl =
          firstStore.querySelector('small');

        const firstStoreName = firstStoreNameEl
          ? firstStoreNameEl.textContent.trim()
          : '';

        const firstStoreTime = firstStoreTimeEl
          ? firstStoreTimeEl.textContent.trim()
          : '';

        if (!firstStoreName) return;

        const available = this.isAvailable(firstStore);

        const previewInfo = preview.querySelector(
          '.pickup-availability-info'
        );

        const previewText = preview.querySelector(
          '.pickup-availability-info p'
        );

        let previewSmall = preview.querySelector(
          '.pickup-availability-info small'
        );

        /*
         * ØªØ­Ø¯ÙŠØ« Ø§Ù„Ø£ÙŠÙ‚ÙˆÙ†Ø© Ø­Ø³Ø¨ Ø­Ø§Ù„Ø© Ø£ÙˆÙ„ ÙØ±Ø¹ Ø¨Ø¹Ø¯ Ø§Ù„ØªØ±ØªÙŠØ¨.
         */
        this.updatePreviewIcon(preview, available);

        /*
         * ØªØ­Ø¯ÙŠØ« Ø§Ù„Ù†Øµ Ø­Ø³Ø¨ Ø§Ù„ÙØ±Ø¹ Ø§Ù„Ù…ØªÙˆÙØ±/ØºÙŠØ± Ø§Ù„Ù…ØªÙˆÙØ±.
         */
        if (previewText) {
          if (available) {
            previewText.textContent =
              `Pickup available at ${firstStoreName}`;
          } else {
            previewText.textContent =
              `Pickup currently unavailable at ${firstStoreName}`;
          }
        }

        /*
         * Ø¥Ù†Ø´Ø§Ø¡ Ø³Ø·Ø± ÙˆÙ‚Øª Ø§Ù„ØªØ¬Ù‡ÙŠØ² Ø¥Ø°Ø§ Ù„Ù… ÙŠÙƒÙ† Ù…ÙˆØ¬ÙˆØ¯Ø§Ù‹
         * ÙÙŠ Ø§Ù„Ø¨Ø·Ø§Ù‚Ø© Ø§Ù„Ø£ØµÙ„ÙŠØ©.
         */
        if (
          available &&
          !previewSmall &&
          previewInfo
        ) {
          const textContainer =
            previewText?.parentElement;

          if (textContainer) {
            previewSmall =
              document.createElement('small');

            previewSmall.className =
              '_ux-rif text-xs leading-tight';

            textContainer.appendChild(previewSmall);
          }
        }

        if (previewSmall) {
          if (available && firstStoreTime) {
            previewSmall.textContent = firstStoreTime;
            previewSmall.removeAttribute('hidden');
          } else if (available) {
            const timeMatch = firstStoreText.match(
              /usually ready.*?(?:hours?|days?|minutes?)/i
            );

            if (timeMatch) {
              previewSmall.textContent = timeMatch[0];
              previewSmall.removeAttribute('hidden');
            } else {
              previewSmall.textContent = '';
              previewSmall.setAttribute('hidden', '');
            }
          } else {
            previewSmall.textContent = '';
            previewSmall.setAttribute('hidden', '');
          }
        }
      }

      renderPreview(sectionInnerHTML) {
        const oldDrawers = document.querySelectorAll(
          '.pickup-availability-drawer'
        );

        oldDrawers.forEach((drawer) => {
          drawer.remove();
        });

        if (!sectionInnerHTML) {
          this.renderError();
          return;
        }

        const preview = sectionInnerHTML.querySelector(
          '.pickup-availability-preview'
        );

        const drawer = sectionInnerHTML.querySelector(
          '.pickup-availability-drawer'
        );

        if (!preview) {
          this.innerHTML = '';
          this.removeAttribute('available');
          this.setAttribute('hidden', '');
          return;
        }

        let firstSortedStore = null;

        if (drawer) {
          const lists = drawer.querySelectorAll(
            'ul, .pickup-availability-list, .pickup-availability-drawer__list'
          );

          lists.forEach((list) => {
            const children = Array.from(list.children);

            const hasStores = children.some((child) => {
              const text = child.textContent || '';

              return /pickup available|pickup currently unavailable|usually ready|ready in|unavailable|Ù…ØªÙˆÙØ±|ØºÙŠØ± Ù…ØªÙˆÙØ±/i.test(
                text
              );
            });

            if (!hasStores) return;

            this.sortStoreCards(list);

            if (!firstSortedStore && list.children.length) {
              firstSortedStore = list.children[0];
            }
          });

          if (firstSortedStore) {
            this.updatePreviewFromFirstStore(
              preview,
              firstSortedStore
            );
          }
        }

        this.innerHTML = preview.outerHTML;
        this.removeAttribute('hidden');
        this.setAttribute('available', '');

        if (drawer) {
          document.body.appendChild(drawer);
        }
      }
    }
  );
}